import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/absoluta.webp';
import screenshot_target from '../../../images/letterfunnel/marcelhoogendoorn.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Marcel Hoogendoorn"
      firstname="Marcel"
      companyname="Absoluta"
      competition="EatFirst en Thuisbezorgd Zakelijk"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/marcelhoogendoorn.js